import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import cartConfig from "emun.cart/cart.config";
import shoppingConfig from "emun.shopping/shopping.config";
import retailerConfig from "emun.retailer/retailer.config";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import resolve from "ioc/resolve";
import required from "emun.order/_required";
// import moment from "moment";$localStorage");
const $localStorage = resolve("$localStorage");
import Product from "emun.shopping/product.model";

export default class OrderDetailsPromptController {
  constructor(options, $session, $location,$timeout) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$timeout = $timeout;
    $ctrl.bus = new ServiceBus();
    $ctrl.config = Object.assign({}, cartConfig, shoppingConfig, orderConfig);
    if ($ctrl.$session.isCorpOrAbove()) $ctrl.config.virtualSources = null;
    $ctrl.retailerConfig = retailerConfig;
    $ctrl.labels = labels;
    $ctrl.retainCustomer = false;
    $ctrl.nextRoute =
      options.nextRoute ||
      $ctrl.config.defaultDetailRoute ||
      "orders.detail.shop";
    if ($ctrl.$session.isShowroom()) {
      $ctrl.nextRoute = "quick-order";
    }
    const o = Object.assign({}, options.model, options.order);
    //console.info("o", o);
    $ctrl.mode = o.mode;
    $ctrl.summary = o.summary;
    $ctrl.order = {
      id: o.id || o.cartId || o.orderId,
      status: o.status || o.orderStatus || o.cartStatus,
      type: o.type || o.transactionType || o.orderType || o.mode,
      shippingLocation: o.shippingLocation,
      purchaser: o.purchaser,
      reviewedBy: o.reviewedBy,
      shippingLocationId: o.shippingLocation
        ? o.shippingLocation.id
        : o.shippingLocationId,
      buyer: o.buyer || o.contactId || o.contact,
      paymentTermsId: o.paymentTerms
        ? o.paymentTerms.id
        : o.paymentTermsId || $session.meta["DefaultTerms"],
      purchaseOrder: o.purchaseOrder,
      warehouseId:
        o.warehouse && o.warehouse.id ? o.warehouse.id : o.warehouseId,
      containerId:
        o.container && o.container.id ? o.container.id : o.containerId,
      email: o.email,
      createContactEmail: o.createContactEmail,
      phone: o.phone,
      vendorNote: o.vendorNote,
      tagFor: o.tagFor,
      retailerId:
        o.retailerId && o.retailerId !== ""
          ? o.retailerId
          : o.retailer && o.retailer.id
          ? o.retailer.id
          : o.purchaser && o.purchaser.id
          ? o.purchaser.id
          : null,
      shippingMethodId: o.shippingMethod
        ? o.shippingMethod.id
        : o.shippingMethodId || $session.meta["DefaultShipMethod"],
      cartName: o.cartName || o.orderPrefix || o.prefix,
      cancelOn: o.cancelOn
        ? o.cancelOn
        : ($session.isShowroom() && $session.meta["DefaultCancelDate"]) ? moment.utc($session.meta["DefaultCancelDate"])
        : $ctrl.config.cancelDateDays
        ? moment.utc().startOf("day").add("days", $ctrl.config.cancelDateDays)
        : null,
      shipOns: o.shipOns,
      shipOn: o.shipOn
        ? o.shipOn : ($session.isShowroom() && $session.meta["DefaultShipDate"]) ? moment.utc($session.meta["DefaultShipDate"])
        : moment
            .utc()
            .startOf("day")
            .add("days", $ctrl.config.shipDateDays || 0),
      note: o.note,
      priceList: o.priceList,
      discountPercentage: o.discountPercentage,
      shipComplete: o.shipComplete || false,
      showCode: o.showCode,
      showCodeId:
        o.showCode && o.showCode.Id
          ? o.showCode.id
          : $session.isShowroom()
          ? o.showCodeId ||
            $session.meta["ShowCode"] ||
            $session.meta["DefaultOrderSourceShow"]
          : o.showCodeId || "",
      location: o.location,
      exported: o.exported,
      allowBackorders: o.allowBackorders,
      shipCompplete: o.shipComplete,
      location: o.location,
      repFax: o.repFax,
      source: o.source,
      sourceId:
        o.source && o.source.id
          ? o.source.id
          : $ctrl.summary
          ? "Direct"
          : $session.isShowroom()
          ? $session.meta["DefaultOrderSourceShow"]
          : $session.isCorpOrAbove()
          ? $session.meta["DefaultOrderSourceCorp"]
          : !$ctrl.config.virtualSources || $ctrl.config.virtualSources == null
          ? $session.meta["DefaultOrderSourceRoad"]
          : "",
      vendorId: o.vendor && o.vendor.id ? o.vendor.id : o.vendorId,
      salesRepId: o.salesRepId,
      //writingRepId: o.writingRepId,
      shippingNote:
        o.shippingNote ||
        (!cartConfig.hideShippingNotes && cartConfig.defaultShippingNote
          ? cartConfig.defaultShippingNote
          : ""),
      freight: o.freight,
      orderedOn: o.orderedOn,
      canEdit: o.canEdit,
      agencyCanEdit: o.agencyCanEdit,
      subscribeEmails: o.subscribeEmails,
      authorizeDecline: o.authorizeDecline,
      resend: false,
      custom1: o.custom1,
    };
    //console.info("order", $ctrl.order);
    if (!$ctrl.order.id && $ctrl.summary) {
      $ctrl.order.orderedOn = moment
      .utc()
      .startOf("day")
    }
    //console.info("BL*** sourceId = " + $ctrl.order.sourceId);
    $ctrl.order.retailer = {
      id: $ctrl.order.retailerId || "",
      companyName:
        o.retailer && o.retailer.companyName
          ? o.retailer.companyName
          : o.purchaser && o.purchaser.companyName
          ? o.purchaser.companyName
          : o.companyName || "",
    };
    if (
      !$ctrl.order.id &&
      ((o.retailer && o.retailer.discount) || (o.shippingLocation  && o.shippingLocation.discount)) &&
      orderConfig.defaultRetailerDiscount
    )
      $ctrl.order.discountPercentage = o.shippingLocation.discount > 0 ? o.shippingLocation.discount : o.retailer.discount;
    if (
        !$ctrl.order.id &&
        o.retailer && o.retailer.paymentTerms
      )
        $ctrl.order.paymentTermsId = o.retailer.paymentTerms;
  
    //console.debug("$ctrl.order", { order: $ctrl.order, o });

    $ctrl.$location = resolve("$location");
    $ctrl.title =
      options.title ||
      ($ctrl.order.id
        ? "Update " + $ctrl.order.id
        : "Create " + (o.mode || "Order")) + "...";
    if (
      $ctrl.config.startOrderMinInfo && !$ctrl.summary &&
      $ctrl.order.retailer.id &&
      !$ctrl.order.id &&
      !orderConfig.virtualSources
    ) {
      $ctrl.bus
        .send(
          "QueryRetailerShippingLocations.json?Status=Active&op=OrderHeaderFieldset&RetailerId=" +
            $ctrl.order.retailer.id
        )
        .then((res) => {
          if (res.data.results.length === 1) {
            $ctrl.order.shippingLocation = res.data.results[0];
            $ctrl.order.shippingLocationId = res.data.results[0].id;
            $ctrl.save();
          }
        });
    }
    $ctrl.originalPriceList = $ctrl.order.priceList;
  }

  createShipLocation() {
    let $ctrl = this;
    if ($ctrl.retailerConfig.newLocationConfirmation) {
      return modals
        .confirm(
          "Are you sure you want to create a new shipping location?",
          "Create Shipping Location"
        )
        .result.then(function () {
          $ctrl.$dismiss({ createShippingLocation: $ctrl.order });
        });
    } else {
      $ctrl.$dismiss({ createShippingLocation: $ctrl.order });
    }
  }

  save() {
    const $ctrl = this;
    const $notify = resolve("notify");
    $ctrl.order.businessModel = "Wholesale";
    $ctrl.order.purchaser = $ctrl.order.retailer;
    if ($ctrl.summary && !$ctrl.order.id) {
      $ctrl.order.exported = true;
      $ctrl.order.balance =
        $ctrl.order.balanceTotal || $ctrl.order.summaryTotal;
      $ctrl.order.status = "Open";
    }
    if (
      required.shippingLocationId &&
      ($ctrl.order.shippingLocationId === "" ||
        $ctrl.order.shippingLocationId == undefined)
    ) {
      $ctrl.bus.validationErrors = [];
      $ctrl.bus.validationErrors.push([{
        errorCode: "-1",
        fieldName: "shipId",
        message: "You must select a shipping location"
      }]);
      //modals.alert("You must select a shipping location");
      return;
    }
    if (
      $ctrl.labels.sourceId &&
      $ctrl.config.virtualSources &&
      !$ctrl.$session.isShowroom() &&
      !$ctrl.order.sourceId
    ) {
      $ctrl.bus.validationErrors = [];
      $ctrl.bus.validationErrors.push([{
        errorCode: "-1",
        fieldName: "sourceId",
        message: "You must select an order source"
      }]);
      // modals.alert("You must select an order source");
      return;
    }
    //if (!$ctrl.order.cartName) $ctrl.order.cartName = '' + new Date().getTime();
    if ($ctrl.summary) $ctrl.order.type = "Direct Order";
    const url = `${
      $ctrl.order.id ? "ApplyOrderHeaderInfo" : "CreateCart"
    }.json?jsconfig=ua,uaa`;
    $ctrl.bus.send(url, $ctrl.order).then(function (response) {
      //console.info("Save $ctrl", $ctrl);
      $ctrl.$cart.ordersInSession().forEach((o) => {
        if (o.id === response.data.id) {
          o.name = response.data.cartName || response.data.id;
          o.companyName = response.data.purchaser.companyName;
          o.customerID = response.data.purchaser.id;
        }
      });
      //if ($ctrl.order.showCodeId) $localStorage.showCodeId = $ctrl.order.showCodeId;
      $ctrl.$emit("orderSaved", $ctrl);
      $ctrl.$cart.load(response.data.id).then(function () {
        //console.info("Close Order $ctrl", $ctrl);
        //console.debug("Close Order $ctrl", $ctrl.order.id, $ctrl.summary, $ctrl.order.vendorId);
        if (!$ctrl.summary || !$ctrl.retainCustomer) $ctrl.$close(response.data);
        if ($ctrl.order.id == undefined || !$ctrl.order.id) {
          if ($ctrl.summary) {
            //add summary item
            $ctrl.product = new Product({
              id: "SUMMARY",
              unlisted: true,
              vendorId: $ctrl.order.vendorId,
              tag: null,
            });
            $ctrl.product.minimumOrderQty = $ctrl.product.quantity = 1;
            $ctrl.product.wholesalePrice =
              $ctrl.product.listPrice =
              $ctrl.product.retailPrice =
              $ctrl.product.priceOverride =
              $ctrl.product.price =
                $ctrl.order.summaryTotal;
            $ctrl.product.unlisted = true;
            $ctrl.product.pricing = { 1: $ctrl.product.price };
            if ($ctrl.product.id[0] !== "*")
              $ctrl.product.id = "*" + $ctrl.product.id;


              //changed this to call AddCartItem directly as the cart service additem is not recognized for some reason
            $ctrl.bus.send("AddCartItem.json", $ctrl.product.createCartItem(
                          null,
                          null,
                          1,
                          $ctrl.product.asShownValues,
                          null,
                          $ctrl.shipOn || null
                        ),
            )
            .then((res) => {
              $ctrl.$emit("cart-item-added", res);
            });

            // $ctrl.$cart
            //   .addItem(
            //     $ctrl.product.createCartItem(
            //       null,
            //       null,
            //       1,
            //       $ctrl.product.asShownValues,
            //       null,
            //       $ctrl.shipOn || null
            //     ), $ctrl.product
            //   )
            //   .then((res) => {
            //     $ctrl.$emit("cart-item-added", res);
            //   });
          }
          //console.debug("$ctrl.nextRoute", $ctrl.nextRoute, response.data.id);
          if (
            !$ctrl.$state.current.name.startsWith("shop") && !$ctrl.$state.current.name.startsWith("product-list-group") && 
            !$ctrl.$state.current.name.startsWith("catalog") &&
            $ctrl.$state.current.name.indexOf("checkout") === -1
          ) {
            if ($ctrl.summary) {
              $notify.success("Direct order created for $" + $ctrl.order.summaryTotal, {
                title: "Direct Order",
                ttl: 5000,
                disableCountDown: true,
              });
              $ctrl.clearSummaryFields();
              if (!$ctrl.retainCustomer) {
                $ctrl.$state.transitionTo("orders", {
                orderId: response.data.id,
                });
              } else {
                $ctrl.$timeout(() => {
                  const wrapper = document.getElementById('purchaseOrder');
                  if (wrapper) {
                    const input = wrapper.querySelector('input[type="text"]');
                    if (input) {
                      input.focus();
                    }
                  }
                }, 0);
                
                
              }
    //              $ctrl.$dismiss({directOrder: $ctrl.order});
            } else {
              $ctrl.$state.transitionTo($ctrl.nextRoute, {
                ...$ctrl.$state.params,
                orderId: response.data.id,
              });
            }
          } else {
            if ($ctrl.originalPriceList !== response.data.priceList) window.location.reload();
          }
        } else {
            if ($ctrl.originalPriceList !== response.data.priceList) window.location.reload();
        }
      });
    });
  }

  clearSummaryFields() {
    const $ctrl = this;
    $ctrl.order.summaryTotal = 0;
    $ctrl.order.balanceTotal = 0;
    $ctrl.order.purchaseOrder = "";
    $ctrl.order.shipOn = ($ctrl.$session.isShowroom() && $ctrl.$session.meta["DefaultShipDate"]) ? moment.utc($ctrl.$session.meta["DefaultShipDate"])
    : moment
        .utc()
        .startOf("day")
        .add("days", $ctrl.config.shipDateDays || 0);
  $ctrl.order.orderedOn = moment
        .utc()
        .startOf("day");
  
  }

  delete() {
    const $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete " + ($ctrl.mode || "Order"))
      .result.then(function () {
        $ctrl.bus
          .send("DeleteOrder.json", $ctrl.order)
          .then(function (response) {
            $ctrl.$close($ctrl.order);
            $ctrl.$emit("orderDeleted", $ctrl);
            $ctrl.$state.transitionTo("^.^");
          });
      });
  }
}
